<template>
    <form id="comentario-form" @submit.prevent="submit" class="ajax_off">
        <div class="form-group">
            <label>Comentário:</label>
            <textarea
                class="form-control"
                name="comentario"
                v-model="comment.comentario"
            ></textarea>
        </div>

        <b-form-group label="Marque uma opção" v-slot="{ ariaDescribedby }">
            <b-form-radio-group
                v-model="comment.option_id"
                :options="options"
                :aria-describedby="ariaDescribedby"
                name="option_id"
                stacked
            ></b-form-radio-group>
        </b-form-group>
    </form>
</template>
<script>
export default {
    props: {
        current_item: Object
    },
    data() {
        return {
            comment: {
                id: null,
                comentario: null,
                option_id: null,
                item_id: null
            },
            options: []
        };
    },
    created() {
        if (this.current_item.comment) {
            this.comment = this.current_item.comment;
        } else {
            this.comment.item_id = this.current_item.id;
        }

        this.getOptions();
    },
    methods: {
        getOptions() {
            this.$api.get("tarefa-checklist-comment-options").then(json => {
                this.options = json.data;
            });
        },
        submit() {
            if (this.comment.id) {
                this.$api
                    .put(
                        `tarefa-checklist-item-comment/${this.comment.id}`,
                        this.comment
                    )
                    .then(() => {
                        this.$bvModal.hide("checklist-item-comentario");
                        this.$emit("updateItem");
                    });
            } else {
                this.$api
                    .post("tarefa-checklist-item-comment", this.comment)
                    .then(() => {
                        this.$bvModal.hide("checklist-item-comentario");
                        this.$emit("updateItem");
                    });
            }
        }
    }
};
</script>
